// DO NOT EDIT -- generated from fs/services/emissary/streams.proto

import * as mapping from './mapping';
import * as protobuf from '../../../google/protobuf';

export namespace Streams {

  export const GetMappingEndpoint = "/grpc/emissary.Streams/GetMapping";
  export function GetMapping(sender: (req: GetMappingRequest, endpoint: string) => Promise<GetMappingResponse>, req: GetMappingRequest): { promise: () => Promise<GetMappingResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetMappingEndpoint),
      endpoint: GetMappingEndpoint
    };
  }

  export const SetMappingEndpoint = "/grpc/emissary.Streams/SetMapping";
  /**
   * SetMapping sets how signal match data should be mapped to the destination payload.
   * If a mapping ID is present in the payload, this acts as an update.
   * If a mapping ID is not present, a new mapping will be created.
   */
  export function SetMapping(sender: (req: SetMappingRequest, endpoint: string) => Promise<SetMappingResponse>, req: SetMappingRequest): { promise: () => Promise<SetMappingResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetMappingEndpoint),
      endpoint: SetMappingEndpoint
    };
  }

  export const ListMappingsEndpoint = "/grpc/emissary.Streams/ListMappings";
  /**
   * ListMappings returns mappings based on the provided filters.
   * Currently provided for internal use only. UI use cases to be added later if necessary.
   * If no filters are provided, all mappings for the org will be returned.
   */
  export function ListMappings(sender: (req: ListMappingsRequest, endpoint: string) => Promise<ListMappingsResponse>, req: ListMappingsRequest): { promise: () => Promise<ListMappingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListMappingsEndpoint),
      endpoint: ListMappingsEndpoint
    };
  }

  export const DeleteMappingEndpoint = "/grpc/emissary.Streams/DeleteMapping";
  /**
   * DeleteMapping permanently deletes the mapping.
   * Don't allow this to be called from the UI at this moment.
   */
  export function DeleteMapping(sender: (req: DeleteMappingRequest, endpoint: string) => Promise<{}>, req: DeleteMappingRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteMappingEndpoint),
      endpoint: DeleteMappingEndpoint
    };
  }

  export const CreateSecretEndpoint = "/grpc/emissary.Streams/CreateSecret";
  export function CreateSecret(sender: (req: CreateSecretRequest, endpoint: string) => Promise<CreateSecretResponse>, req: CreateSecretRequest): { promise: () => Promise<CreateSecretResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateSecretEndpoint),
      endpoint: CreateSecretEndpoint
    };
  }

  export const UpdateSecretEndpoint = "/grpc/emissary.Streams/UpdateSecret";
  export function UpdateSecret(sender: (req: UpdateSecretRequest, endpoint: string) => Promise<UpdateSecretResponse>, req: UpdateSecretRequest): { promise: () => Promise<UpdateSecretResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSecretEndpoint),
      endpoint: UpdateSecretEndpoint
    };
  }

  export const ListSecretsEndpoint = "/grpc/emissary.Streams/ListSecrets";
  export function ListSecrets(sender: (req: ListSecretsRequest, endpoint: string) => Promise<ListSecretsResponse>, req: ListSecretsRequest): { promise: () => Promise<ListSecretsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListSecretsEndpoint),
      endpoint: ListSecretsEndpoint
    };
  }

  export const DeleteSecretEndpoint = "/grpc/emissary.Streams/DeleteSecret";
  export function DeleteSecret(sender: (req: DeleteSecretRequest, endpoint: string) => Promise<{}>, req: DeleteSecretRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteSecretEndpoint),
      endpoint: DeleteSecretEndpoint
    };
  }

  export const ExecuteSampleMappingEndpoint = "/grpc/emissary.Streams/ExecuteSampleMapping";
  /**
   * ExecuteSampleMapping executes a mapping with sample data provided by the client. Real secret values will not be
   * used - instead, fake secret values will be used.
   */
  export function ExecuteSampleMapping(sender: (req: ExecuteSampleMappingRequest, endpoint: string) => Promise<ExecuteSampleMappingResponse>, req: ExecuteSampleMappingRequest): { promise: () => Promise<ExecuteSampleMappingResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ExecuteSampleMappingEndpoint),
      endpoint: ExecuteSampleMappingEndpoint
    };
  }

  export const GetStreamOauthEndpoint = "/grpc/emissary.Streams/GetStreamOauth";
  export function GetStreamOauth(sender: (req: GetStreamOauthRequest, endpoint: string) => Promise<GetStreamOauthResponse>, req: GetStreamOauthRequest): { promise: () => Promise<GetStreamOauthResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetStreamOauthEndpoint),
      endpoint: GetStreamOauthEndpoint
    };
  }

  export const CreateStreamOauthEndpoint = "/grpc/emissary.Streams/CreateStreamOauth";
  export function CreateStreamOauth(sender: (req: CreateStreamOauthRequest, endpoint: string) => Promise<CreateStreamOauthResponse>, req: CreateStreamOauthRequest): { promise: () => Promise<CreateStreamOauthResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateStreamOauthEndpoint),
      endpoint: CreateStreamOauthEndpoint
    };
  }

  export const UpdateStreamOauthEndpoint = "/grpc/emissary.Streams/UpdateStreamOauth";
  export function UpdateStreamOauth(sender: (req: UpdateStreamOauthRequest, endpoint: string) => Promise<UpdateStreamOauthResponse>, req: UpdateStreamOauthRequest): { promise: () => Promise<UpdateStreamOauthResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateStreamOauthEndpoint),
      endpoint: UpdateStreamOauthEndpoint
    };
  }

  export const DeleteStreamOauthEndpoint = "/grpc/emissary.Streams/DeleteStreamOauth";
  export function DeleteStreamOauth(sender: (req: DeleteStreamOauthRequest, endpoint: string) => Promise<{}>, req: DeleteStreamOauthRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteStreamOauthEndpoint),
      endpoint: DeleteStreamOauthEndpoint
    };
  }

  export const CreateConnectionEndpoint = "/grpc/emissary.Streams/CreateConnection";
  /**
   * Connections APIs
   * CreateConnection creates a new connection along with the given auth config.
   */
  export function CreateConnection(sender: (req: CreateConnectionRequest, endpoint: string) => Promise<CreateConnectionResponse>, req: CreateConnectionRequest): { promise: () => Promise<CreateConnectionResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateConnectionEndpoint),
      endpoint: CreateConnectionEndpoint
    };
  }

  export const GetConnectionEndpoint = "/grpc/emissary.Streams/GetConnection";
  /** GetConnection retrieves the connection and the associated auth config. */
  export function GetConnection(sender: (req: GetConnectionRequest, endpoint: string) => Promise<GetConnectionResponse>, req: GetConnectionRequest): { promise: () => Promise<GetConnectionResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetConnectionEndpoint),
      endpoint: GetConnectionEndpoint
    };
  }

  export const UpdateConnectionEndpoint = "/grpc/emissary.Streams/UpdateConnection";
  /**
   * UpdateConnection updates the connection and the associated auth config.
   * It returns an error if the auth type is changed. To change the auth type, delete the connection and create a new
   * one.
   */
  export function UpdateConnection(sender: (req: UpdateConnectionRequest, endpoint: string) => Promise<UpdateConnectionResponse>, req: UpdateConnectionRequest): { promise: () => Promise<UpdateConnectionResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateConnectionEndpoint),
      endpoint: UpdateConnectionEndpoint
    };
  }

  export const DeleteConnectionEndpoint = "/grpc/emissary.Streams/DeleteConnection";
  /** DeleteConnection deletes the connection and the associated auth config. */
  export function DeleteConnection(sender: (req: DeleteConnectionRequest, endpoint: string) => Promise<{}>, req: DeleteConnectionRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteConnectionEndpoint),
      endpoint: DeleteConnectionEndpoint
    };
  }

  export const ListBareConnectionsEndpoint = "/grpc/emissary.Streams/ListBareConnections";
  /** ListBareConnections returns all connections for an organization. */
  export function ListBareConnections(sender: (req: ListBareConnectionsRequest, endpoint: string) => Promise<ListBareConnectionsResponse>, req: ListBareConnectionsRequest): { promise: () => Promise<ListBareConnectionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListBareConnectionsEndpoint),
      endpoint: ListBareConnectionsEndpoint
    };
  }
}

export interface GetMappingRequest {
  orgId: string;
  configId: string;
}

export interface GetMappingResponse {
  record: MappingRecord | null;
}

export interface ListMappingsRequest {
  orgId: string;
  serviceId: string;
}

export interface ListMappingsResponse {
  records: MappingRecord[];
}

export interface SetMappingRequest {
  orgId: string;
  /** The id of the integration provider. */
  serviceId: string;
  /** The id of the integration config. */
  configId: string;
  /**
   * If present, the id of an existing config.
   * If not present, a new config will be created.
   */
  id: number;
  /**
   * Optional ID of the Connection object. If set, this stream will use the Connection object and its associated auth
   * config to send data.
   */
  connectionId: number;
  mapping: mapping.Mapping | null;
  /**
   * If true, mapped properties will be used as the payload sent to the associated destination. Otherwise, properties
   * will be nested within the standard payload.
   */
  hoistProperties: boolean;
}

export interface SetMappingResponse {
  record: MappingRecord | null;
}

export interface DeleteMappingRequest {
  orgId: string;
  id: number;
}

export interface MappingRecord {
  /** The unique identifier for the mapping record. */
  id: number;
  /** The id of the integration provider. */
  serviceId: string;
  /** The integration config associated with this mapping. */
  configId: string;
  /** The id of the connection associated with this mapping. If empty, it uses the legacy stream flow. */
  connectionId: number;
  /** The mapping definition. */
  mapping: mapping.Mapping | null;
  /** The time the record was created. */
  createdAt: protobuf.timestamp | null;
  /** The user who created the record. */
  createdBy: string;
  /** The time the record was last updated. */
  updatedAt: protobuf.timestamp | null;
  /** The user who last updated the record. */
  updatedBy: string;
  /** Use mapped properties as the payload if true. Otherwise, use standard webhook payload. */
  hoistProperties: boolean;
}

export interface Secret {
  /** Primary key */
  id: number;
  /** The integration config associated with this secret */
  configId: string;
  /** The name used in the UI to refer to this secret */
  name: string;
  /** The encrypted value of the secret */
  value: string;
  createdAt: protobuf.timestamp | null;
  createdBy: string;
  updatedAt: protobuf.timestamp | null;
  updatedBy: string;
}

export interface ListSecretsRequest {
  orgId: string;
  configId: string;
}

export interface ListSecretsResponse {
  /** The secret value will be masked */
  secrets: Secret[];
}

export interface CreateSecretRequest {
  orgId: string;
  configId: string;
  name: string;
  value: string;
}

export interface CreateSecretResponse {
  /** The secret value will be masked */
  secret: Secret | null;
}

export interface UpdateSecretRequest {
  orgId: string;
  id: number;
  configId: string;
  name: string;
  /**
   * Optional, if not set the value will not be updated.
   * This allows you to change the name of the secret without knowing the unecrypted value.
   */
  value: string | null;
}

export interface UpdateSecretResponse {
  /** The secret value will be masked */
  secret: Secret | null;
}

export interface DeleteSecretRequest {
  orgId: string;
  id: number;
  /** config_id is used for cache invalidation */
  configId: string;
}

export interface SecretCacheEntry {
  secrets: Secret[];
}

export interface ExecuteSampleMappingRequest {
  mapping: mapping.Mapping | null;
  properties: protobuf.Struct[];
}

export interface ExecuteSampleMappingResponse {
  payload: protobuf.Struct | null;
}

export interface StreamOauth {
  /** Primary key */
  id: number;
  /** The integration config associated with this secret */
  configId: string;
  /** The ID of the Connection object associated with this StreamOauth config. */
  connectionId: number;
  /** TODO(sanjay): Make this a oneof with the other grant types (a.k.a. flows). */
  clientCredentialsFlow: StreamOauth.ClientCredentialsFlow | null;
  createdAt: protobuf.timestamp | null;
  createdBy: string;
  updatedAt: protobuf.timestamp | null;
  updatedBy: string;
}

export namespace StreamOauth {
  /** TODO(sanjay): Consider removing client_secret from this message to prevent accidentally leaking it. */
  export interface ClientCredentialsFlow {
    clientId: string;
    /** The encrypted value of the secret */
    clientSecret: string;
    tokenUrl: string;
    /** URL encoded */
    endpointParams: string;
    scopes: string[];
  }
}

export interface GetStreamOauthRequest {
  orgId: string;
  configId: string;
}

export interface GetStreamOauthResponse {
  streamOauth: StreamOauth | null;
}

export interface CreateStreamOauthRequest {
  orgId: string;
  configId: string;
  /** The ID of the Connection object associated with this StreamOauth config. */
  connectionId: number;
  clientCredentialsFlow: OAuthClientCredentials | null;
}

export interface CreateStreamOauthResponse {
  streamOauth: StreamOauth | null;
}

export interface UpdateStreamOauthRequest {
  orgId: string;
  id: number;
  configId: string;
  /** Optional, if set, the connection ID will be updated. */
  connectionId: number | null;
  clientCredentialsFlow: UpdateStreamOauthRequest.ClientCredentialsFlow | null;
}

export namespace UpdateStreamOauthRequest {
  /** TODO(sanjay): Use OAuthOptional instead of ClientCredentialsFlow. */
  export interface ClientCredentialsFlow {
    clientId: string;
    /** Optional, if not set the value will not be updated. */
    clientSecret: string | null;
    tokenUrl: string;
    endpointParams: string;
    scopes: string[];
  }
}

export interface UpdateStreamOauthResponse {
  streamOauth: StreamOauth | null;
}

export interface DeleteStreamOauthRequest {
  orgId: string;
  id: number;
  /** config_id is used for cache invalidation */
  configId: string;
}

export interface OAuthClientCredentials {
  clientId: string;
  clientSecret: string;
  tokenUrl: string;
  endpointParams: string;
  scopes: string[];
}

/** OAuthRequired is used in requests, such as Create requests, where the fields are required in the auth config. */
export interface OAuthRequired {
  oauthClientCredentials?: OAuthClientCredentials | null;
}

/** OAuthRequired is used in requests, such as Create requests, where the fields are required in the auth config. */
export namespace OAuthRequired {
  export enum flow {
    oauthClientCredentials = 1
  }

  export function flow_oneof(m: OAuthRequired): { opt: flow.oauthClientCredentials, val: OAuthClientCredentials } | null {
    if (m.oauthClientCredentials != null) { return { opt: flow.oauthClientCredentials, val: m.oauthClientCredentials } }
    return null;
  }
}

/**
 * RepeatedStringValue supports repeated string fields that are optional, because when a `repeated string` field results
 * in the same serialization for an empty slice and a nil slice.
 */
export interface RepeatedStringValue {
  values: string[];
}

export interface OAuthClientCredentialsOptional {
  clientId: string | null;
  clientSecret: string | null;
  tokenUrl: string | null;
  endpointParams: string | null;
  scopes: RepeatedStringValue | null;
}

/** OAuthOptional is used in requests, such as Update requests, where the fields are optional in the auth config. */
export interface OAuthOptional {
  oauthClientCredentials?: OAuthClientCredentialsOptional | null;
}

/** OAuthOptional is used in requests, such as Update requests, where the fields are optional in the auth config. */
export namespace OAuthOptional {
  export enum flow {
    oauthClientCredentials = 1
  }

  export function flow_oneof(m: OAuthOptional): { opt: flow.oauthClientCredentials, val: OAuthClientCredentialsOptional } | null {
    if (m.oauthClientCredentials != null) { return { opt: flow.oauthClientCredentials, val: m.oauthClientCredentials } }
    return null;
  }
}

export interface BasicAuthRequired {
  username: string;
  password: string;
}

export interface BasicAuthOptional {
  username: string | null;
  password: string | null;
}

/** Safe version of BasicAuth that doesn't expose the password */
export interface BasicAuthSafe {
  id: number;
  username: string;
  createdAt: protobuf.timestamp | null;
  createdBy: string;
  updatedAt: protobuf.timestamp | null;
  updatedBy: string;
}

export interface BearerTokenRequired {
  token: string;
}

export interface BearerTokenOptional {
  token: string | null;
}

/** Safe version of BearerToken that doesn't expose the token value */
export interface BearerTokenSafe {
  id: number;
  createdAt: protobuf.timestamp | null;
  createdBy: string;
  updatedAt: protobuf.timestamp | null;
  updatedBy: string;
}

/** Enum for API Key location */
export enum APIKeyLocation {
  API_KEY_LOCATION_UNSPECIFIED = 0,
  API_KEY_LOCATION_HEADER = 1,
  API_KEY_LOCATION_QUERY_PARAMS = 2
}

export interface APIKeyRequired {
  key: string;
  value: string;
  addTo: APIKeyLocation;
}

export interface APIKeyLocationOptional {
  location: APIKeyLocation;
}

export interface APIKeyOptional {
  key: string | null;
  value: string | null;
  addTo: APIKeyLocationOptional | null;
}

/** Safe version of APIKey that doesn't expose the key value */
export interface APIKeySafe {
  id: number;
  key: string;
  addTo: APIKeyLocation;
  createdAt: protobuf.timestamp | null;
  createdBy: string;
  updatedAt: protobuf.timestamp | null;
  updatedBy: string;
}

export interface Connection {
  /** ID is the unique connection ID */
  id: number;
  orgId: string;
  name: string;
  createdAt: protobuf.timestamp | null;
  createdBy: string;
  updatedAt: protobuf.timestamp | null;
  updatedBy: string;
  unauthenticated?: {} | null;
  oauth?: StreamOauth | null;
  basicAuth?: BasicAuthSafe | null;
  bearerToken?: BearerTokenSafe | null;
  apiKey?: APIKeySafe | null;
}

export namespace Connection {
  /** Indicates the authentication method used for this connection. At least one of the auth fields will be set. */
  export enum auth {
    unauthenticated = 7,
    oauth = 8,
    basicAuth = 10,
    bearerToken = 11,
    apiKey = 12
  }

  /** Indicates the authentication method used for this connection. At least one of the auth fields will be set. */
  export function auth_oneof(m: Connection): { opt: auth.apiKey, val: APIKeySafe } | { opt: auth.basicAuth, val: BasicAuthSafe } | { opt: auth.bearerToken, val: BearerTokenSafe } | { opt: auth.oauth, val: StreamOauth } | { opt: auth.unauthenticated, val: {} } | null {
    if (m.unauthenticated != null) { return { opt: auth.unauthenticated, val: m.unauthenticated } }
    if (m.oauth != null) { return { opt: auth.oauth, val: m.oauth } }
    if (m.basicAuth != null) { return { opt: auth.basicAuth, val: m.basicAuth } }
    if (m.bearerToken != null) { return { opt: auth.bearerToken, val: m.bearerToken } }
    if (m.apiKey != null) { return { opt: auth.apiKey, val: m.apiKey } }
    return null;
  }
}

export interface ConnectionWithCredentials {
  /** ID is the unique connection ID */
  id: number;
  orgId: string;
  name: string;
  createdAt: protobuf.timestamp | null;
  createdBy: string;
  updatedAt: protobuf.timestamp | null;
  updatedBy: string;
  unauthenticated?: {} | null;
  oauth?: StreamOauth | null;
  basicAuth?: BasicAuthRequired | null;
  bearerToken?: BearerTokenRequired | null;
  apiKey?: APIKeyRequired | null;
}

export namespace ConnectionWithCredentials {
  /** Indicates the authentication method used for this connection. At least one of the auth fields will be set. */
  export enum auth {
    unauthenticated = 8,
    oauth = 9,
    basicAuth = 11,
    bearerToken = 12,
    apiKey = 13
  }

  /** Indicates the authentication method used for this connection. At least one of the auth fields will be set. */
  export function auth_oneof(m: ConnectionWithCredentials): { opt: auth.apiKey, val: APIKeyRequired } | { opt: auth.basicAuth, val: BasicAuthRequired } | { opt: auth.bearerToken, val: BearerTokenRequired } | { opt: auth.oauth, val: StreamOauth } | { opt: auth.unauthenticated, val: {} } | null {
    if (m.unauthenticated != null) { return { opt: auth.unauthenticated, val: m.unauthenticated } }
    if (m.oauth != null) { return { opt: auth.oauth, val: m.oauth } }
    if (m.basicAuth != null) { return { opt: auth.basicAuth, val: m.basicAuth } }
    if (m.bearerToken != null) { return { opt: auth.bearerToken, val: m.bearerToken } }
    if (m.apiKey != null) { return { opt: auth.apiKey, val: m.apiKey } }
    return null;
  }
}

export interface CreateConnectionRequest {
  orgId: string;
  name: string;
  unauthenticated?: {} | null;
  oauth?: OAuthRequired | null;
  basicAuth?: BasicAuthRequired | null;
  bearerToken?: BearerTokenRequired | null;
  apiKey?: APIKeyRequired | null;
}

export namespace CreateConnectionRequest {
  /** Auth config to create. At least one of the auth fields must be provided. */
  export enum auth {
    unauthenticated = 2,
    oauth = 3,
    basicAuth = 5,
    bearerToken = 6,
    apiKey = 7
  }

  /** Auth config to create. At least one of the auth fields must be provided. */
  export function auth_oneof(m: CreateConnectionRequest): { opt: auth.apiKey, val: APIKeyRequired } | { opt: auth.basicAuth, val: BasicAuthRequired } | { opt: auth.bearerToken, val: BearerTokenRequired } | { opt: auth.oauth, val: OAuthRequired } | { opt: auth.unauthenticated, val: {} } | null {
    if (m.unauthenticated != null) { return { opt: auth.unauthenticated, val: m.unauthenticated } }
    if (m.oauth != null) { return { opt: auth.oauth, val: m.oauth } }
    if (m.basicAuth != null) { return { opt: auth.basicAuth, val: m.basicAuth } }
    if (m.bearerToken != null) { return { opt: auth.bearerToken, val: m.bearerToken } }
    if (m.apiKey != null) { return { opt: auth.apiKey, val: m.apiKey } }
    return null;
  }
}

export interface CreateConnectionResponse {
  connection: Connection | null;
}

export interface GetConnectionRequest {
  orgId: string;
  /** The connection ID */
  id: number;
}

export interface GetConnectionResponse {
  connection: Connection | null;
}

export interface UpdateConnectionRequest {
  orgId: string;
  /** The connection ID */
  id: number;
  /** The connection name to update. Optional. */
  name: string | null;
  unauthenticated?: {} | null;
  oauth?: OAuthOptional | null;
  basicAuth?: BasicAuthOptional | null;
  bearerToken?: BearerTokenOptional | null;
  apiKey?: APIKeyOptional | null;
}

export namespace UpdateConnectionRequest {
  /**
   * Auth config to update. If none are provided, the existing auth config will be retained. To remove authentication,
   * set unauthenticated to an empty object.
   */
  export enum auth {
    unauthenticated = 3,
    oauth = 4,
    basicAuth = 6,
    bearerToken = 7,
    apiKey = 8
  }

  /**
   * Auth config to update. If none are provided, the existing auth config will be retained. To remove authentication,
   * set unauthenticated to an empty object.
   */
  export function auth_oneof(m: UpdateConnectionRequest): { opt: auth.apiKey, val: APIKeyOptional } | { opt: auth.basicAuth, val: BasicAuthOptional } | { opt: auth.bearerToken, val: BearerTokenOptional } | { opt: auth.oauth, val: OAuthOptional } | { opt: auth.unauthenticated, val: {} } | null {
    if (m.unauthenticated != null) { return { opt: auth.unauthenticated, val: m.unauthenticated } }
    if (m.oauth != null) { return { opt: auth.oauth, val: m.oauth } }
    if (m.basicAuth != null) { return { opt: auth.basicAuth, val: m.basicAuth } }
    if (m.bearerToken != null) { return { opt: auth.bearerToken, val: m.bearerToken } }
    if (m.apiKey != null) { return { opt: auth.apiKey, val: m.apiKey } }
    return null;
  }
}

export interface UpdateConnectionResponse {
  connection: Connection | null;
}

export interface DeleteConnectionRequest {
  orgId: string;
  /** The connection ID */
  id: number;
}

export interface ListBareConnectionsRequest {
  orgId: string;
}

export enum AuthType {
  AUTH_TYPE_UNSPECIFIED = 0,
  AUTH_TYPE_UNAUTHENTICATED = 1,
  AUTH_TYPE_OAUTH = 2,
  AUTH_TYPE_BASIC_AUTH = 3,
  AUTH_TYPE_BEARER_TOKEN = 4,
  AUTH_TYPE_API_KEY = 5
}

export interface BareConnection {
  /** ID is the unique connection ID */
  id: number;
  orgId: string;
  name: string;
  authType: AuthType;
  createdAt: protobuf.timestamp | null;
  createdBy: string;
  updatedAt: protobuf.timestamp | null;
  updatedBy: string;
}

export interface ListBareConnectionsResponse {
  connections: BareConnection[];
}
